module.exports = __webpack_public_path__ + "static/media/language-earth.f40369ef.svg";